var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"miami"},[_c('ScrollupSection'),_c('div',{staticClass:"all-area"},[_c('HeaderSection'),_c('HeroSection'),_c('PromoSection'),_c('AboutSection'),_c('NewsletterSection'),_c('PricingSection'),_c('FaqSection'),_c('FooterSection')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }